export const yellowAuricula = '#FFEF00'

export const pinkAuricula = '#FF7070'

export const blackAuricula = '#000000'

export const whiteAuricula = '#FFFFFF'

export const greyAuricula = '#B4C3D5'